import { FunctionComponent } from 'react';

import { imageResizer } from 'utils/image';

import LayoutContainer from 'components/layout/LayoutContainer';

import { Props } from './index';
import StyledComponent from './style';


const PublicLayoutSectionsHeroAlt: FunctionComponent<Props> = ({
    title,
    subtitle,
    background,
    backgroundAlt,
}) => {
    return (
        <StyledComponent className='public-layout-section-hero-alt'>
            <img
                className='background'
                src={imageResizer(background, { width: 1920 })}
                loading="lazy"
                alt={backgroundAlt}
                id="top"
            />
            <LayoutContainer>
                <div className="hero-txt">
                    {title && (
                        <div className="title-wrapper">
                            <h1
                                className="title"
                                dangerouslySetInnerHTML={{ __html: title }}
                            />
                        </div>
                    )}
                    {subtitle && (
                        <div
                            className="subtitle"
                            dangerouslySetInnerHTML={{ __html: subtitle }}
                        />
                    )}
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicLayoutSectionsHeroAlt;